// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b2e9aeb2","707":"8127a322","828":"c24579c5"}[chunkId] + ".chunk.js";
};